import api, { buildQueryString } from './api';
import type {
  Geofence,
  PaginatedResponse,
  ApiResponse,
  PaginationParams,
} from '../types';

export interface CreateGeofenceData {
  customerId: string;
  radius: number;
  latitude: number;
  longitude: number;
}

export const geofenceService = {
  async getAll(params?: PaginationParams & { customerId?: string }): Promise<PaginatedResponse<Geofence>> {
    const qs = buildQueryString(params as Record<string, unknown>);
    const response = await api.get<PaginatedResponse<Geofence>>(`/api/geofences${qs}`);
    return response.data;
  },

  async getById(id: string): Promise<Geofence> {
    const response = await api.get<ApiResponse<Geofence>>(`/api/geofences/${id}`);
    return response.data.data;
  },

  async getByCustomer(customerId: string): Promise<Geofence> {
    const response = await api.get<ApiResponse<Geofence>>(`/api/geofences/customer/${customerId}`);
    return response.data.data;
  },

  async create(data: CreateGeofenceData): Promise<Geofence> {
    const response = await api.post<ApiResponse<Geofence>>('/api/geofences', data);
    return response.data.data;
  },

  async update(id: string, data: Partial<CreateGeofenceData>): Promise<Geofence> {
    const response = await api.patch<ApiResponse<Geofence>>(`/api/geofences/${id}`, data);
    return response.data.data;
  },

  async updateRadius(id: string, radius: number): Promise<Geofence> {
    const response = await api.patch<ApiResponse<Geofence>>(`/api/geofences/${id}/radius`, { radius });
    return response.data.data;
  },

  async toggleStatus(id: string): Promise<Geofence> {
    const response = await api.patch<ApiResponse<Geofence>>(`/api/geofences/${id}/toggle`);
    return response.data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/api/geofences/${id}`);
  },
};
